import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const MdBanner = Loadable({
    loader: () => import(/* webpackChunkName: "MdBanner" */ './mdBanner'),
    loading: () => <div />,
});
